module.exports = __webpack_public_path__ + "img/case_homies_portrait.82b303c6.jpg";